import React, {useRef} from 'react';
import styled from "styled-components";
import {CaptionListProps} from "../../../types/caption";
import {useAtom} from "jotai";
import {captionItemState, captionListState} from "../../../states/caption";
import {playerState} from "../../../states/player";
import {timestamp2seconds} from "../../../helper/helper";
import {saveState} from "../../../states/action";
import {PeaksInstance} from 'peaks.js';

declare global {
  var peaksInstance: PeaksInstance | undefined
}
type CaptionDataProps = { captionData: CaptionListProps }

/**
 자막 데이터 (글)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */
export default function CaptionData({captionData}: CaptionDataProps) {

  const [{playOn}, setPlayer] = useAtom(playerState);
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [captionList, setCaptionList] = useAtom(captionListState);
  const [, setCaptionItem] = useAtom(captionItemState);
  const [, setSave] = useAtom(saveState);
  const isMouseDownRef = useRef(false)
  const initialMouseXPos = useRef<number | null>(null)
  const initialWidth = useRef<number | null>(null)

  // useEffect(() => {

  //   window.addEventListener('mousemove', (e) => {

  //     if(!(isMouseDownRef.current && initialMouseXPos.current && wrapperRef.current)) {return }
  //     const currentXPos = e.screenX

  //     let cachedResizeWidth : null | number = null
  //     Array.from(document.querySelectorAll('.can_resizable_textarea')).map((textarea, i) => {
  //       cachedResizeWidth = cachedResizeWidth ? cachedResizeWidth : ((initialWidth.current!) + ((initialMouseXPos!.current! - currentXPos) / 3)) + 2;
  //       (textarea as HTMLTextAreaElement).style.width = `${cachedResizeWidth}px`
  //     })
  //   })

  //   window.addEventListener('mouseup', () => {
  //     isMouseDownRef.current = false
  //   })
  // }, []);

  // const setResizeOn : React.MouseEventHandler<HTMLDivElement>  = e => {
  //     initialMouseXPos.current = e.screenX
  //     initialWidth.current = e.currentTarget.clientWidth
  //     isMouseDownRef.current = true
  // }

  return (
    <DataArea className="" style={{flexShrink: 1}}>
      <div ref={wrapperRef}
           className="can_resizable2 txt_area"
           style={{width: "400px", flexShrink: 1}}
        // className=''
        // onMouseDown={setResizeOn}
      >
        <label htmlFor="caption_txt1" className="hide">자막</label>
        <textarea
          // className="can_resizable_textarea input_text modified_input_text type_align_left"
          className="input_text modified_input_text type_align_left"
          name="caption"
          placeholder="자막을 입력하세요"
          maxLength={100}
          data-id={captionData.id}
          value={captionData.caption}
          onClick={() => !playOn && setCaptionItem((prev) => ({
            ...prev,
            captionSelectedOn: true,
            captionSelectedId: captionData.seq
          }))}
          onDoubleClick={() => setPlayer((prev) => {
            globalThis.peaksInstance?.player.seek(timestamp2seconds(captionData.time_ini));
            return {
              ...prev,
              seekOnTime: timestamp2seconds(captionData.time_ini),
              currentTime: timestamp2seconds(captionData.time_ini)
            }
          })}
          onChange={(e) => {

            const cuurrentSegmentId = e.currentTarget.dataset.id!
            const targetSegment = globalThis.peaksInstance?.segments.getSegment(cuurrentSegmentId)
            if (targetSegment
              && captionData) {
              const [_1stLine, _2ndLine] = targetSegment.labelText!.split('\n\n')!
              const [segmentSequenceStr,] = _1stLine.split(' ')!;
              targetSegment.update({labelText: `${_1stLine} \n\n${e.currentTarget.value}`});
            }

            const captionListUpdated = captionList.map((segment, index) => {
              return segment.id === cuurrentSegmentId
                ? {
                  ...segment,
                  caption: e.currentTarget.value
                } as CaptionListProps
                : segment
            })
            setCaptionList(captionListUpdated);
            setSave({needSaveOn: true});
          }}
        ></textarea>
      </div>
    </DataArea>
  );
}

const DataArea = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  /* -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1; */
  /* flex: 1 1 1; */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  z-index: 10;
  padding: 0 5px 0 0;

  .txt_area {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    position: relative;
    height: 100%;
    padding: 0 0 0 5px;
    line-height: 25px;
    text-align: center;

    .input_text {
      height: 100%;
      padding: 12px;
      font-size: 17px;
      overflow: hidden;
      overflow-y: auto;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        -webkit-border-radius: 3px;
        border-radius: 3px;
        background: #3e3e3e;
      }

      &::-webkit-scrollbar-track-piece {
        background: #1f1f1f;
      }

    }

  }
`;
